function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Button from './button';

/**
 * A wrapper around the {@link Button} component that adds `type="submit"`. Generally used in the context of forms.
 *
 * With the exception of `type`, this component shares the same props as {@link Button}.
 *
 * @name SubmitButton
 * @type Function
 * @example
 *
 * function PersonForm ({ handleSubmit, pristine, invalid, submitting }) {
 *   return (
 *     <form onSubmit={ handleSubmit }>
 *       <Field name="name" component={ Input } />
 *       <Field name="age" component={ Input } type="number" />
 *       <SubmitButton {...{ pristine, invalid, submitting }}>
 *         Submit
 *       </SubmitButton>
 *     </form>
 *   )
 * }
 *
 * // When SubmitButton is pressed, form will submit and handleSubmit() will be called.
 */

function SubmitButton(props) {
  return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
    type: "submit"
  }));
}
export default SubmitButton;